import { IconProps } from 'src/utils/icon';

const DownloadIcon: React.FC<IconProps> = ({ size = 1, fill = '#000' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0625 17.75H0.9375C0.417969 17.75 0 17.332 0 16.8125V15.875C0 15.3555 0.417969 14.9375 0.9375 14.9375H14.0625C14.582 14.9375 15 15.3555 15 15.875V16.8125C15 17.332 14.582 17.75 14.0625 17.75ZM11.4688 6.79297L8.90625 9.35547V1.1875C8.90625 0.667969 8.48828 0.25 7.96875 0.25H7.03125C6.51172 0.25 6.09375 0.667969 6.09375 1.1875V9.35547L3.53125 6.79297C3.16406 6.42578 2.57031 6.42578 2.20703 6.79297L1.54297 7.45703C1.17578 7.82422 1.17578 8.41797 1.54297 8.78125L6.83594 14.0742C7.20312 14.4414 7.79687 14.4414 8.16016 14.0742L13.4531 8.78125C13.8203 8.41406 13.8203 7.82031 13.4531 7.45703L12.7891 6.79297C12.4258 6.42578 11.832 6.42578 11.4688 6.79297Z"
      fill={fill}
    />
  </svg>
);

export default DownloadIcon;
